export default "__VITE_ASSET__03f21bd6__"